import { m } from "framer-motion";
import cx from "classnames";

import style from "./stats.module.css";

const stats = [
  { number: "5", caption: "years writing production code" },
  { number: "8", caption: "greenfield apps built" },
  { number: "52", caption: "consecutive weeks shipping" },
  { number: "100", caption: "percent test coverage on PRs" },
];

const Stats = () => {
  return (
    <div>
      {stats.map(({ number, caption }, i) => (
        <m.div
          key={number}
          initial={{ opacity: 0, y: 45 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 3 + i * 0.3 }}
          className="mb-6"
        >
          <p
            className={cx(
              "text-4xl sm:text-6xl font-bold font-title",
              style.shine
            )}
          >
            {number}
          </p>
          <p className="text-lg font-medium font-title text-green-600">
            {caption}
          </p>
        </m.div>
      ))}
    </div>
  );
};

export default Stats;
